import { forwardRef } from 'react';
import { Icon, disableCache } from '@iconify/react';

import { cn } from 'src/utils/cn';

import { iconifyClasses } from './classes';

import type { IconifyProps } from './types';

// ----------------------------------------------------------------------

export const Iconify = forwardRef<SVGSVGElement, IconifyProps>(
  ({ className, width = 20, style, ...other }, ref) => (
    <Icon
      ssr
      ref={ref}
      className={cn(iconifyClasses.root, 'inline-flex shrink-0', className)}
      style={{
        width,
        height: width,
        ...style,
      }}
      {...other}
    />
  )
);

// https://iconify.design/docs/iconify-icon/disable-cache.html
disableCache('local');
